export default {
  // Navigation
  nav: {
    home: 'Home',
    practice: 'Practice',
    comprehensive: 'Comprehensive',
    donate: 'Donate',
    readMe: 'Read Me',
    translationTool: 'Agentic Translation Studio',
    translationServices: 'Translation Services',
    apiTutorial: 'API Tutorial',
    terminologyTool: 'Terminology Tool',
    wordCountTool: 'Word Count Tool',
    wordFrequencyTool: 'Word Frequency Tool',
    corpusAlignmentTool: 'Corpus Alignment Tool',
    otherTools: 'Other Tools',
    studyTools: 'English Major Exam Benefits',
    cattiPractice: 'CATTI Practice System',
    featureNotOpen: 'This feature is not available yet',
    cattiComprehensive: 'CATTI Comprehensive System',
  },

  // Landing Page
  landing: {
    title: 'O-max',
    subtitle: 'Studio',
    tagline: 'Beyond Translation, Reshaping the Translation Industry',
    enterSite: 'Enter Studio',
    intro: 'O-max Studio stands at the forefront of translation technology. It goes beyond translation to reshape the translation industry. Traditional computer-assisted translation (CAT) tools often suffer from limited format support, insufficient AI integration, and suboptimal user experiences, relying on workflows in which humans lead and machines merely assist. To address these industry challenges, O-max has pioneered the IAT agentic translation paradigm, covering the entire pre-translation, translation, and post-translation process. It supports a wide range of content, including office documents, video and streaming media, and design files, enabling a new generation of workflows led by machines and supervised by humans. O-max Agentic Translation Studio follows the reasoning process of professional translators to automate drafting, polishing, and review, effectively overcoming persistent problems in conventional machine translation and large language models, such as unnatural translationese and inconsistent terminology. O-max has also developed proprietary parsing and export engines for images, PDF, and DWG files, integrating multimodal document processing to address long-standing challenges including OCR inaccuracies, mistranslated formulas, and semantic discontinuity. This creates a complete end-to-end workflow from original document content and layout input to production-ready delivery, providing next-generation language solutions for academic research, global content distribution, and commercial projects.',
    agentTitle: 'Pricing',
    enterpriseTitle: 'Partner Program',
    partnerLifetime: 'Premium Membership',
    partnerIndividual: 'Independent Translators',
    partnerAcademic: 'University Faculty & Students',
    partnerLimitedTime: 'Limited Offer',
    partnerEnterprise: 'Enterprise Strategic Partnership',
    partnerContact: 'Contact Support',
    translationPricing: 'Translation Software Pricing',
    businessCooperation: 'Business Cooperation',
    technicalSupport: 'Technical Support',
    officialAccount: 'Official Account',
    officialAccountName: 'Meta Translate',
    // Navigation
    navMetaTranslate: 'Team Introduction',
    navAIFAQ: 'AI Q&A',
    navTranslationSoftware: 'Translation Software',
    navToolsAndPricing: 'Tools Download & Pricing',
    // AI Quick Q&A
    aiFAQTitle: 'AI Quick Q&A',
    faq1Question: 'What are an API Key and a Token?',
    faq1Answer: 'Think of them as a mobile carrier and a SIM card. The API Key is the access credential your provider issues, and it decides which AI service you can connect to; the Token is like the data plan on the card — every time the AI thinks or generates text, Tokens are consumed, and you need to top up when they run out. In short: the API Key answers "can I connect?", the Token answers "how much is left?".',
    faq2Question: 'Why does the software need an API Key and Token top-up to work?',
    faq2Answer: 'The software is like a phone: it organises your documents, terminology and instructions, but translation, polishing and review all require calling an AI service online. The API Key connects the software to that service, and the Token is the available quota. You need both before the software can send a request and bring the result back.',
    faq3Question: 'Why does AI translation come out one character at a time?',
    faq3Answer: 'That is "streaming output". The AI has actually worked out the whole answer already, but to let you see results sooner — and to stop people hammering the API — it pushes the answer out in small chunks, which looks like it is typing one character at a time.',
    faq4Question: 'The configuration looks correct, so why do AI translation or polishing calls occasionally fail?',
    faq4Answer: 'It is usually not your configuration but fluctuations on the service side: an unstable network, temporary congestion on the model side, exhausted quota or a rate-limited Key can all cause a failed call. Retry once first; if it still fails, switch to another model or try again later.',
    faq5Question: 'How is AI translation different from ordinary machine translation?',
    faq5Answer: 'Ordinary machine translation relies on word-by-word and sentence-by-sentence rule matching, so it is fast but reads stiffly. AI translation is built on large language models: it reads the context, understands tone, keeps terminology consistent, and produces more natural output — much better suited to professional documents.',
    faq6Question: 'Why use an API Key at all? Can I not just use the web page?',
    faq6Answer: 'The web page is a shared public entrance with usage and input-length limits, and it cannot process documents in bulk. An API Key is a dedicated channel: batch calls, your own parameters, integration into your own workflow — far better suited to professional use.',
    faq7Question: 'Why does the API Key cost money while the web page is free?',
    faq7Answer: 'The web version is free because usage counts and session length are capped, which keeps costs controllable. API Keys are billed by usage — higher volume and concurrency mean the corresponding computing cost has to be covered.',
    faq8Question: 'What is the difference between official AI and third-party resellers?',
    faq8Answer: 'Official services are operated by the provider itself, so pricing is transparent, responses are fast and stability is good. Third-party resellers are often cheaper, but may come with rate limits, service cut-offs or data-security risks. For important projects, prefer official channels.',
    faq9Question: 'Can I install AI software on my own computer?',
    faq9Answer: 'Yes, but the hardware bar is high — you need enough VRAM and memory. An ordinary office PC can only run very small models, and output quality suffers. In most cases, using an API Key with a cloud service is far less trouble.',
    faq10Question: 'What is the "AI rate"?',
    faq10Answer: 'The AI rate is a proportional estimate of how likely a piece of text was generated by AI. Detection tools judge it from word choice, sentence patterns and expression habits, but it is only a probability reference — not conclusive proof that AI was used, and misjudgements do happen.',
    faq11Question: 'What are "AI traces"?',
    faq11Answer: 'AI traces are the features in a text that make people or detection tools read it as machine-generated. Common ones include:\n· Sentences that are too neat and symmetrical, lacking natural variation\n· Overly formal or templated wording, such as "firstly / secondly / finally" or "in conclusion"\n· Paragraphs of near-identical structure, with no sign of a personal writing habit\n· Vague content that lacks concrete detail or real experience',
    faq12Question: 'When using AI to generate content, how do I avoid obvious AI traces?',
    faq12Answer: 'A few practical steps:\n· Rewrite by hand after generating — adjust sentence patterns and word order so it matches your own voice\n· Replace templated phrasing and add concrete cases, data and detail\n· Break up paragraphs that are too uniformly structured\n· Add personal touches drawn from your own experience\n· Have important texts proofread by a human to make sure facts are right and the logic flows',
    faq13Question: 'Can I actually use AI? I am worried about the risks.',
    faq13Answer: 'It depends on the purpose and the rules that apply:\n· For understanding material, drafting and organising information, it is usually safe and efficient\n· For coursework, theses or reports you submit formally, follow your institution\'s rules — label AI use or limit its scope as required\n· Never upload classified or sensitive content to public AI services\n· Use "AI generates, a human checks" — efficient without giving up responsibility',
    faq14Question: 'Can I do post-editing on translations? Will it be detected?',
    faq14Answer: 'Post-editing is standard industry practice — machine translation plus human polishing is itself a conventional workflow, so there is no question of it being "against the rules". Whether it gets detected depends on the client\'s specific requirements on AI use: if fully human translation is explicitly required, confirm with them in advance; if there is no such restriction, post-editing improves efficiency while maintaining quality.',
    // Translation Software Section
    translationSoftwareTitle: 'Innovation Highlights',
    innovationFeatures: {
      feature1: 'Full integration with mainstream AI and machine translation engines',
      feature2: 'Proprietary PDF algorithm for better layout and translation quality',
      feature3: 'Supports importing dictionaries in mdx and other formats',
      feature4: 'Document image reconstruction restores original image content and layout',
      feature5: 'Database integration to reuse translation assets',
      feature6: 'Translation and thinking workflows',
      feature7: 'For more features, please see "Agentic Translation Studio"'
    },
    // Tools and Pricing Section
    toolsAndPricingTitle: 'Tools Download & Pricing',
    corpusAlignmentTool: 'Corpus Alignment Tool',
    terminologyCreationTool: 'Terminology Creation Tool',
    wordCountingTool: 'Word Counting Tool',
    wordSegmentationTool: 'Word Segmentation Tool',
    cattiPracticeSystem: 'CATTI Practice System',
    cattiComprehensiveSystem: 'CATTI Comprehensive System',
    // Pricing
    pricingTitle: 'Unified Pricing System',
    pricingSubtitle: 'All tools use unified pricing - simple and transparent',
    pricingNote: '* One machine one code binding, authorization cancellation not supported',
    free: 'Free',
    internalInterns: 'Internal Interns Only',
    // Tools List
    availableTools: 'Available Tools',
    // Download Links
    downloadLinks: 'Download Links',
    baiduNetdisk: 'Baidu Netdisk',
    quarkNetdisk: 'Quark Netdisk',
    teraboxNetdisk: 'TeraBox (Recommended)',
    // WeChat Contact
    wechatContact: 'WeChat Contact',
    wechatContactHint: 'Scan to add WeChat',
    scanQRCode: 'Scan QR Code',
    wechatDescription: 'Scan the QR code to add our customer service WeChat for more product information and special offers'
  },

  // Tool Page Common
  toolPage: {
    features: 'Features',
    demonstration: 'Demonstration',
    visualDemo: 'Visual Display · Operation Demo · At a Glance',
    simpleOperation: 'Simple Operation · Powerful Features · Efficiency Boost',
    fastImport: 'Fast Import · Accurate Statistics · Convenient Export',
    intelligentSegmentation: 'Intelligent Segmentation · Precise Search · Efficient Statistics',
    targetUsers: 'Target Users'
  },

  // Common Tool Target Users (for tools without specific content)
  commonTool: {
    targetUsers: {
      title: 'Target Users',
      subtitle: 'Practical tools suitable for various professional scenarios',
      feature1: {
        title: 'Academic Researchers',
        content: 'Professionals who need to process large amounts of documents, analyze data, and organize content'
      },
      feature2: {
        title: 'Content Creators',
        content: 'Practitioners including editors, journalists, copywriters who need efficient text processing'
      },
      feature3: {
        title: 'Language Learners',
        content: 'Learners who need to analyze text structure and word distribution during language learning'
      },
      feature4: {
        title: 'Data Analysts',
        content: 'Professionals who need to extract key information and statistics from text'
      }
    }
  },

  // Translation Tool
  translationTool: {
    title: 'Advanced Translation Tool',
    subtitle: 'Professional Translation Tool · Intelligent AI Assistance · Ultimate Experience',
    // Numbering is generated by ToolPageLayout from the display order, so titles stay unnumbered here.
    feature1: {
      title: 'Multilingual Support',
      content: 'Translates between more than 200 languages (Chinese, English, Russian, Japanese, Korean, French, Spanish, Thai, Indonesian, Dutch and more), and more can be added'
    },
    feature2: {
      title: 'Multi-format Support',
      content: 'Handles documents (docx, pptx, xlsx, PDF), video and subtitles (ass, srt), web pages (HTML), design and engineering files (InDesign, Photoshop, Illustrator, DWG, DXF) and translation exchange formats (xliff, sdlxliff) — and more can be added'
    },
    feature3: {
      title: 'Export Function',
      content: 'Supports multiple export formats: source text, target text, side-by-side bilingual and stacked bilingual'
    },
    feature4: {
      title: 'Match Translation',
      content: 'Import a corpus (Excel or sdlxliff documents) to translate by matching, pairing source and target texts automatically'
    },
    feature5: {
      title: 'Interactive Experience',
      content1: 'Clean and beautiful interface, simple operation (open program → drag and drop document → free translation from "Machine Translation" dropdown menu)',
      content2: 'Starts fast and stays lightweight — the program keeps to a very small footprint, so it runs comfortably even on older machines'
    },
    feature6: {
      title: 'AI Features (Chat, Translation, Polishing, Proofreading, Terminology Extraction)',
      content1: 'Supports cloud large language models (OpenAI format compatible), with longer context than Trados plugins',
      content2: 'Supports local large language models (Ollama format compatible), works offline, suitable for classified data security'
    },
    feature7: {
      title: 'Custom Spelling Check & Terminology Standards Check',
      content1: 'Supports annotation of translation cells for proofreading',
      content2: 'And more'
    },
    feature8: {
      title: 'Document Management Function',
      content: 'Supports document management and search functions, quickly locate and manage translation projects'
    },
    feature9: {
      title: 'Calendar Function',
      content: 'Supports calendar function, translation delivery dates at a glance, making project management more efficient'
    },
    feature10: {
      title: 'Document Distribution Function',
      content: 'Supports document and data distribution, facilitating team collaboration and improving overall project efficiency'
    },
    feature11: {
      title: 'Terminology Intervention & Detection Function',
      content: 'Supports terminology intervention, customizable violation word detection and other settings, ensuring translation quality and compliance'
    },
    feature12: {
      title: 'Notes Function',
      content: 'Supports document notes and global notes for efficient learning and work, making translation more convenient and efficient'
    },
    feature13: {
      title: 'Terminology Database Creation Function',
      content: 'Supports terminology database creation, quick collection and export of document terminology, making professional terminology management more efficient'
    },
    feature14: {
      title: 'Custom Background Image & Theme Colour',
      content: 'Set your own background image and theme colour to make the workspace your own'
    },
    feature15: {
      title: 'More Features to Explore',
      content: 'Updated continuously — more practical features are on the way'
    },
    feature16: {
      title: 'Workflow & Background Batch Processing',
      content1: 'Chain pre-translation → polishing → proofreading → export into one workflow and let it run in the background, unattended',
      content2: 'Queue several documents at once and keep working in the UI while they process — no more waiting on a long file'
    },
    feature17: {
      title: 'LLM Hallucination Detection & Tracked Changes',
      content1: 'Compares source and target segment by segment, flagging omissions, additions and mistranslated numbers or proper nouns',
      content2: 'Every AI edit lands as a tracked change you can review, accept or roll back one by one'
    },
    feature18: {
      title: 'Translation Memory Lookup',
      content1: 'Query the translation memory at any point while translating and drop a hit straight into the current cell — no switching out to search manually',
      content2: 'Confirmed segments go straight back into the TM, staying in step with the document you are working on'
    },
    feature20: {
      title: 'Machine Translation',
      content1: 'Several cloud MT engines are built in — drop a document in and pre-translate the whole file in one click, free out of the box',
      content2: 'Local offline engines are supported too, so you can keep translating with no network and keep sensitive material in house'
    },
    feature19: {
      title: 'Conversational Refinement',
      content1: 'Select any translation cell and say how it should change — shorter, more formal, a different term — and the model rewrites it on the spot',
      content2: 'Apply the same instruction across the whole document to align style and terminology in one pass'
    },
    // Target Users gets its own panel in ToolPageLayout, with its own side-nav entry.
    targetUsers: {
      title: 'Target Users',
      subtitle: 'Different scenarios · Pick the one that fits',
      feature1: {
        title: 'Research Paper Readers',
        content: 'Open research PDFs and read them side by side: formulas, sub/superscripts and figure numbers stay intact — and this part is completely free.'
      },
      feature2: {
        title: 'Foreign Trade Professionals',
        content: 'Translate technical documents and bilingual quotations in one click, with the original layout preserved so the file is ready to send.'
      },
      feature3: {
        title: 'MTI University Students',
        content: 'Export the side-by-side bilingual format practice reports require, while terminology and corpora accumulate along the way.'
      },
      feature4: {
        title: 'CATTI Exam Candidates',
        content: 'Automatic review flags spelling, collocation and grammar issues sentence by sentence, so practice runs give you feedback close to exam standards.'
      }
    }
  },

  // Word Count Tool
  wordCountTool: {
    title: 'Word Count Tool',
    subtitle: 'Accurate Statistics · Batch Processing · Safe and Efficient',
    feature1: {
      title: 'Multiple Document Format Support',
      content: 'Fully supports mainstream document formats, including Word documents, Excel spreadsheets, PowerPoint presentations, and plain text files.'
    },
    feature2: {
      title: 'Accurate Text Statistics',
      content: 'Supports Chinese, English, Japanese, Korean, Russian, French, and Spanish statistics, intelligently distinguishes punctuation marks, accurately calculates document pages and file size, ensuring accurate and reliable statistical results.'
    },
    feature3: {
      title: 'Batch Processing Function',
      content: 'Supports folder batch import, one-click processing of multiple documents, supports drag-and-drop file operations, tree structure display of results, making your work efficient and convenient, with clear hierarchy at a glance.'
    },
    feature4: {
      title: 'Data Security & Management',
      content: 'Local data processing, secure storage, no risk of information leakage. Supports one-click export to Excel spreadsheet, making document information organization more convenient and fast.'
    },
    feature5: {
      title: 'Wide Range of Application Scenarios',
      content: 'Suitable for various professional scenarios: academic research (quickly count word count for submissions), publishing and editing (accurately calculate manuscript length), translation work (accurately count source and target text word count for billing), content review (batch processing of documents), document management (organizing and archiving file information).'
    }
  },

  // Word Frequency Tool
  wordFrequencyTool: {
    title: 'Word Frequency Tool',
    subtitle: 'Intelligent Segmentation · Fast Statistics · Precise Search',
    feature1: {
      title: 'Word Segmentation Statistics',
      content: 'Quickly count word frequency in multiple Word and TXT files, supports intelligent word segmentation and result export, allowing you to easily grasp core vocabulary distribution in documents.'
    },
    feature2: {
      title: 'Precise Search Statistics',
      content: 'Provides precise keyword search function, supports case sensitivity and whole word matching modes, helping you quickly locate and count the occurrences of specific vocabulary.'
    },
    feature3: {
      title: 'Wide Range of Application Scenarios',
      content: 'Suitable for academic research (analyzing keyword distribution in literature), market analysis (counting popular word frequency), daily document processing (quickly understanding document core content), and other scenarios.'
    }
  },

  // API Tutorial
  apiTutorial: {
    pageTitle: 'API Tutorial',
    pageSubtitle: '　　Configuring large language models requires two core parameters: Base URL and Model Name. Please follow the format below strictly to avoid configuration failures.\n\n　　✅ Base URL Configuration\n　　Correct example: https://api.siliconflow.cn/v1\n　　Wrong example: https://api.siliconflow.cn/v1/chat/completions\n　　Note: Base URL should end with /v1, excluding subsequent paths like /chat/completions\n\n　　✅ Model Name Configuration\n　　Correct examples: glm-4.5-flash, gpt-4o, claude-3-sonnet\n　　Wrong examples: https://api.openai.com/gpt-4, C:/models/llama, leaving it blank\n　　Note: Only fill in the model identifier (e.g., gpt-4o), not the complete URL or local path\n\n　　💡 Recommended Providers\n　　• Zhipu AI: Offers free glm-4.5-flash model, available for new users\n　　• 302.ai: Provides stable access to ChatGPT, Claude and other international models',
    triggerButton: 'API Tutorial',
    openPanel: 'Open API Tutorial Panel',
    closePanel: 'Close Tutorial Panel',
    closePanelBtn: 'Close Panel',
    panelTitle: 'API Key Application Tutorial',
    panelSubtitle: 'Quick Guide to Obtain API Keys from Major AI Platforms',
    emptyTitle: 'No Tutorial Content Available',
    emptyDesc: 'The API application tutorial for this provider is being prepared...',
    scrollTop: 'Back to Top',
    imageAlt: 'Click to View Tutorial Image',
    // Zhipu AI
    zhipu: {
      step1: {
        title: '1. Register Account',
        content: 'Visit Zhipu AI open platform https://open.bigmodel.cn, complete account registration and identity verification using phone number or email.'
      },
      step2: {
        title: '2. Find API Management Page',
        content: 'After logging in, enter the console and find "API Key" in the upper right corner to access the API configuration page.'
      },
      step3: {
        title: '3. Create API Key',
        content: 'On the API management page, click the "Create API Key" button, enter a name and set permissions, then copy and save the generated API Key.'
      }
    },
    // DeepSeek
    deepseek: {
      step1: {
        title: '1. Visit Website and Login',
        content: 'Open DeepSeek official website https://platform.deepseek.com, click the "Login/Register" button in the upper right corner, and complete registration and login using email or phone number.'
      },
      step2: {
        title: '2. Access API Keys Management',
        content: 'After logging in, click the "API keys" tab on the left side.'
      },
      step3: {
        title: '3. Create and Save API Key',
        content: 'Click the "Create new API Key" button, enter a name and confirm, copy the generated API Key (API Key is only displayed once)'
      }
    },
    // Kimi
    kimi: {
      step1: {
        title: '1. Visit Moonshot AI Website',
        content: 'Open Moonshot AI website https://platform.moonshot.cn, click "Try Now" or "Login".'
      },
      step2: {
        title: '2. Register and Login',
        content: 'Register an account using phone number or email, and login after completing verification.'
      },
      step3: {
        title: '3. Access API Management',
        content: 'After logging in, find the "API Keys" option in the personal center or console.'
      },
      step4: {
        title: '4. Obtain API Key',
        content: 'Click "Create API Key", set name and permissions, copy and save after generation.'
      }
    },
    // SiliconFlow
    siliconflow: {
      step1: {
        title: '1. Visit SiliconFlow Website',
        content: 'Open https://siliconflow.cn, click "Try Now" to enter the registration page.'
      },
      step2: {
        title: '2. Register Account',
        content: 'Register using phone number, receive verification code to complete registration.'
      },
      step3: {
        title: '3. Access Console',
        content: 'After logging in, enter the console and click "API Keys" in the left menu.'
      },
      step4: {
        title: '4. Create API Key',
        content: 'Click "Create New API Key", enter name and description, generate API Key.'
      }
    },
    // 302.ai
    ai302: {
      step1: {
        title: '1. Visit 302.ai Website',
        content: 'Open https://302.ai, click "Login" or "Register" button. (Access to international models available)'
      },
      step2: {
        title: '2. Access Admin Dashboard',
        content: 'Click "Admin Dashboard" in the menu bar.'
      },
      step3: {
        title: '3. Purchase Credits and Access API Key',
        content: 'Purchase API credits as needed, and click "API key" on the left side.'
      },
      step4: {
        title: '4. Generate API Key',
        content: 'Generate API Key and configure permissions.'
      }
    },
    // NiuTrans
    niutrans: {
      step1: {
        title: '1. Visit NiuTrans Website',
        content: 'Open NiuTrans official website https://niutrans.com, click "Login/Register" button in the upper right corner.'
      },
      step2: {
        title: '2. Register Account',
        content: 'Register an account using phone number or email, complete verification and login.'
      },
      step3: {
        title: '3. Access Console',
        content: 'After login, enter "NiuTrans Cloud" console, find translation service in product management.'
      },
      step4: {
        title: '4. Get API Key',
        content: 'Click "Create API Key" in API management page, set name and permissions, copy and save the generated API Key.'
      }
    },
    // Tencent Cloud
    tencent: {
      step1: {
        title: '1. Visit Tencent Cloud Website',
        content: 'Open Tencent Cloud official website https://cloud.tencent.com, click "Free Registration" to complete account registration.'
      },
      step2: {
        title: '2. Identity Verification',
        content: 'Login to console and complete identity verification (requires uploading ID card or facial recognition).'
      },
      step3: {
        title: '3. Activate Machine Translation Service',
        content: 'Search for "Machine Translation" in product search, enter service page and activate the service.'
      },
      step4: {
        title: '4. Get Access Keys',
        content: 'Go to "Access Management > API Key Management" page, click "Create Key" to get SecretId and SecretKey.'
      }
    }
  },

  // Animation Titles
  animations: {
    translationTool: {
      sentenceSwitch: 'Seamless Switching Between Sentence and Paragraph Segmentation',
      machineTranslation: 'Machine Translation for Full Text',
      llmTranslation: 'AI Translation for Full Text',
      llmPolish: 'AI Polishing for Full Text',
      llmReview: 'AI Review for Full Text',
      llmTerminologyExtract: 'AI Terminology Extraction for Full Text',
      llmSummary: 'AI Summary for Full Text',
      llmMindmap: 'AI Mindmap Creation',
      llmTerminologyChat: 'AI Reference Chat',
      bilingualExportSide: 'Side-by-Side Bilingual Export',
      bilingualExportStack: 'Stacked Bilingual Export',
      dictionary: 'Dictionary Feature',
      notes: 'Notes Feature',
      terminologyDb: 'Terminology Database'
    },
    terminologyTool: {
      toolInterface: 'Tool Interface',
      terminologyExtract: 'Terminology Extraction',
      terminologyTest: 'Self-Test Mode',
      terminologyExport: 'Terminology Export'
    },
    wordCountTool: {
      importDocuments: 'Import Documents or Folders',
      batchProcessing: 'Batch Processing',
      statisticsDisplay: 'Tab Display of Language Statistics',
      exportExcel: 'Export to Excel with Clear Data and Beautiful Format'
    },
    wordFrequencyTool: {
      importFiles: 'Import Files',
      wordSegmentation: 'Word Segmentation Statistics',
      keywordSearch: 'Keyword Search',
      exportResults: 'Export Results'
    },
    corpusAlignmentTool: {
      fileImport: 'Document Import',
      clipboardImport: 'Clipboard Import',
      autoAlignment: 'AI-Powered Alignment',
      exportFormats: 'Excel Export'
    }
  },

  // Terminology Tool
  terminologyTool: {
    title: 'Terminology Tool',
    subtitle: 'Efficient Organization · Intelligent Self-test · Simple and Easy to Use',
    feature1: {
      title: 'Solving Pain Points',
      content: 'When reading bilingual texts, we often use highlighting as a way to assist understanding. However, while this method is convenient for reading, it is not convenient to organize the highlighted content into a single document.'
    },
    feature2: {
      title: 'Quick Terminology Database Creation',
      content: 'To solve this pain point, Meta Translate has developed a brand new program. Users simply drag and select text in the document, press [Ctrl+C] to copy, then click the "Add as Source" or "Add as Target" button in the program to easily create a terminology database.'
    },
    feature3: {
      title: 'Export Function',
      content: 'The program also supports exporting the terminology database as a beautifully formatted Excel document, greatly improving the efficiency of organizing and managing bilingual texts.'
    },
    feature4: {
      title: 'Self-test Function',
      content: 'This program provides a "self-test" function. In this mode, the program will randomly extract terms from the terminology database, users can input the corresponding translation based on the source text, and the program will automatically match and determine whether the translation is accurate.'
    }
  },

  // Corpus Alignment Tool
  corpusAlignmentTool: {
    title: 'Corpus Alignment Tool',
    subtitle: 'AI-Powered · Intelligent Alignment · Multi-Model Compatible',
    feature1: {
      title: 'Multiple Import Methods for Flexibility',
      content: 'Supports single document import, dual document import, clipboard import and other methods, compatible with different user habits to make corpus alignment more flexible and convenient.'
    },
    feature2: {
      title: 'AI-Powered with Multi-Model Format Support',
      content: 'Supports cloud-based large language models (OpenAI format compatible) and locally deployed models (Ollama format compatible), works offline for secure data handling in classified environments. AI algorithms precisely identify bilingual correspondence, significantly improving alignment efficiency.'
    },
    feature3: {
      title: 'Excel Export Function',
      content: 'Supports Excel format export to meet different usage scenarios.'
    },
    feature4: {
      title: 'Multi-Language Alignment Support',
      content: 'Supports alignment for multiple languages. If your large language model supports a language, you can align it. Whether it\'s Chinese-English, Chinese-Japanese, English-French, or any other language combination, as long as your LLM understands these languages, you can achieve precise corpus alignment.'
    }
  },
}
